/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamitemidAttachment200,
  GetApiV1ExamExamitemidAttachment401,
  GetApiV1ExamExamitemidAttachment404,
  GetApiV1ExamExamitemidAttachment500,
  GetApiV1ExamExamitemidAttachmentPathParams,
  GetApiV1ExamExamitemidAttachmentQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidAttachment.ts";

export const getApiV1ExamExamitemidAttachmentPathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamitemidAttachmentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamitemidAttachment200Schema =
  z.string() as unknown as ToZod<GetApiV1ExamExamitemidAttachment200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamitemidAttachment401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidAttachment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamitemidAttachment404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidAttachment404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamitemidAttachment500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidAttachment500>;

export const getApiV1ExamExamitemidAttachmentQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamitemidAttachment200Schema,
) as unknown as ToZod<GetApiV1ExamExamitemidAttachmentQueryResponse>;
